import WifiBoxReservationForm  from './WifiBoxReservationForm';

export default WifiBoxReservationForm;
